import { request } from "@/api/client";
import type { ShopifyPayout, ShopifyShop, ShopifyOrder } from "@/types/shopify";

export function connectShopifyShop(payload: {
  shop_domain: string;
  access_token: string;
  currency?: string;
  bank_account_id?: number | null;
  sales_account_id?: number | null;
  fee_account_id?: number | null;
  tax_account_id?: number | null;
}): Promise<ShopifyShop> {
  return request("/shopify/connect", { method: "POST", body: payload });
}

export function listShopifyShops(): Promise<ShopifyShop[]> {
  return request("/shopify/shops");
}

export function pullShopifyOrders(shop_id: string, created_after?: string): Promise<{ orders: number }> {
  return request("/shopify/pull/orders", { method: "POST", body: { shop_id, created_after } });
}

export function pullShopifyPayouts(shop_id: string): Promise<{ payouts: number }> {
  return request("/shopify/pull/payouts", { method: "POST", body: { shop_id } });
}

export function listShopifyPayouts(limit = 50): Promise<ShopifyPayout[]> {
  return request(`/shopify/payouts?limit=${encodeURIComponent(limit)}`);
}

export function journalizeShopifyPayout(payout_id: string, journal_id: number): Promise<ShopifyPayout> {
  return request(`/shopify/payouts/${encodeURIComponent(payout_id)}/journalize`, {
    method: "POST",
    body: { journal_id },
  });
}

export function listShopifyOrders(limit = 50): Promise<ShopifyOrder[]> {
  return request(`/shopify/orders?limit=${encodeURIComponent(limit)}`);
}
